import { UniswapQuoter } from '../UniswapQuoter'

/**
 * The Quoter contract for Uniswap V3 swap quotes.
 *
 * NOTE: The SwapRouter02 uses the same QuoterV2 contract as our direct pool quotes.
 */
const UniswapV3SwapQuoter = UniswapQuoter

export { UniswapV3SwapQuoter }
